export const createAsyncMutation = (type) => ({
	SUCCESS: `${type}_SUCCESS`,
	FAILURE: `${type}_FAILURE`,
	REQUEST: `${type}_REQUEST`,
})

// Authentication
export const LOAD_ESTATES_MUTATION = createAsyncMutation ('LOAD_ESTATES_MUTATION')

// Ethereuem
export const GET_ETHEREUM_VALUE_MUTATION = createAsyncMutation ('GET_ETHEREUM_VALUE_MUTATION')